<main>
  <div class="main-background z--1 w-100 position-absolute bg-cover bg-center"></div>
  <section class="container d-flex flex-column">
    <div class="row align-items-center justify-content-center g-0 min-vh-100">
        <div class="mt-13 text-center"><span class="it-quiz-text f-col fw-bold fs-50px-lh-63px">
          IT&nbsp;<span class="font-outfit col-purple fw-bold fs-50px-lh-63px">Q</span>uiz</span></div>
        <div class="card shadow custom-size col-white mx-auto mb-6 mt-6 h-auto rounded-3 position-relative">
          <div class="card-body p-8 p-30px-24px-40px">
            <div class="mb-3">
              <div *ngIf="message === SUCCESS_VERIFY_LINK">
                <div class="media-screen-w verify-link pt-3 pe-2 pb-3 ps-3 mb-5 g-4 w-100 d-flex rounded-3 position-relative">
                  <img src="../../assets/images/tick/rounded-tick.png" alt="rounded-tick" class="rounded-tick position-absolute">
                  <span class="ms-5 f-col">{{ message }}</span>
                </div>
              </div>
              <div *ngIf="message === EMAIL_ALREADY_EXISTS">
                <div class="media-screen-w invalidity-link pt-3 pe-2 pb-3 ps-3 mb-5 g-4 w-100 d-flex rounded-3 position-relative">
                  <img src="/assets/images/error/cancel.png" alt="cancel" class="rounded-tick position-absolute">
                  <span class="ms-5 f-col">{{ message }}</span>
                </div>
              </div>
              <div class="w-100 text-align-center">
                <span class="sign-up-text f-col fw-bold">Sign Up</span><br>
                <h5 class="d-inline col-grey f-col text-center fw-normal">Already have an account?
                    <a href="/signin" class="ms-1">Sign In</a></h5>
              </div>
            </div>
            <br>
            <form [formGroup]="form" (ngSubmit)="submit()">
              <div class="mb-4">
                <label for="username" class="label-focused form-label ls-01em f-col fw-normal">
                  <h5 class="d-inline">{{ USERNAME_LABEL }}</h5>
                </label>
                <div class="w-483px rounded-3 border-focused">
                <input formControlName="username" type="text" id="username"
                       class="media-screen-w form-control-div pt-3 pb-3 pe-3 ps-3 w-100 border-0 font-outfit g-1 rounded-3"
                       placeholder="User name" autocomplete="new-username">
                </div>
              </div>
              <div class="mb-3">
                <label for="email"
                       class="label-focused form-label ls-01em f-col fw-normal">
                  <h5 class="d-inline" [ngClass]="{
                  'validation': isEmailBlurred && (form.get('email')!.invalid && form.get('email')!.touched)}">
                    {{ EMAIL_LABEL }}</h5>
                </label>
                <div class="w-483px rounded-3 border-focused"
                     [ngClass]="{
                  'border-validation': isEmailBlurred && (form.get('email')!.invalid && form.get('email')!.touched)}">
                <input formControlName="email" type="email" id="email"
                       class="media-screen-w form-control-div pt-3 pb-3 pe-3 ps-3 w-100 border-0 font-outfit g-1 rounded-3"
                       placeholder="Email address" autocomplete="new-email"
                       (focus)="onFocus(EMAIL)"
                       (blur)="onBlur(EMAIL)">
                </div>
                <div class="validation ps-2 pt-1 font-outfit d-flex fw-normal g-1 ls-01em fs-12px-lh-15px"
                     *ngIf="isEmailBlurred && (form.get('email')!.hasError('required') && form.get('email')!.touched)">
                  Email address is Required
                </div>
                <div class="validation ps-2 pt-1 font-outfit d-flex fw-normal g-1 ls-01em fs-12px-lh-15px"
                     *ngIf="isEmailBlurred && (form.get('email')!.hasError('invalidEmailFormat') && form.get('email')!.touched)">
                  Please enter a valid email address
                </div>
              </div>
              <div class="mb-3">
                <label for="password"
                       class="form-label ls-01em f-col fw-normal label-focused">
                  <h5 class="d-inline" [ngClass]="{
                  'validation': isPasswordBlurred && (form.get('password')!.invalid && form.get('password')!.touched)}">
                    {{ PASSWORD_LABEL }}</h5>
                </label>
                <div class="position-relative">
                  <div class="w-483px rounded-3 border-focused"
                       [ngClass]="{
                        'border-validation': isPasswordBlurred && (form.get('password')!.invalid && form.get('password')!.touched)}">
                  <input formControlName="password"
                         [type]="passwordFieldType"
                         id="password"
                         class="media-screen-w form-control-div pt-3 pb-3 pe-3 ps-3 w-100 border-0 font-outfit g-1 rounded-3"
                         placeholder="Enter your password"
                         (keydown)="preventWhitespace($event)" autocomplete="new-password"
                         (focus)="onFocus(PASSWORD)"
                         (blur)="onBlur(PASSWORD)">
                  <h3 class="password-toggle-icon cursor-pointer position-absolute">
                    <i [class]="passwordFieldType === PASSWORD ?  'far fa-eye-slash' : 'far fa-eye'"
                      (click)="togglePasswordVisibility()" class="password-icon-style"></i>
                  </h3>
                  </div>
                </div>
                <div class="ul-li-div mt-1 pt-1 pb-1 pe-2 w-100"
                     *ngIf="!isPasswordBlurred || (isPasswordBlurred && !(form.get('password')!.invalid && form.get('password')!.touched))">
                  <ul class="d-flex list-unstyled p-0 m-0 g-1">
                    <li [ngClass]="{ 'valid': hasUppercase }">
                      <span *ngIf="hasUppercase">
                        <img src="../../assets/images/tick/tick.png" alt="tick" class="tick">
                      </span>
                      <span *ngIf="!hasUppercase">&#8226;</span>
                      <span class="ms-2 fs-12px-lh-15px ls-01em fw-normal">At least 1 uppercase</span>
                    </li>
                    <li [ngClass]="{ 'valid': hasNumber }">
                      <span *ngIf="hasNumber">
                        <img src="../../assets/images/tick/tick.png" alt="tick" class="tick">
                      </span>
                      <span *ngIf="!hasNumber">&#8226;</span>
                      <span class="ms-2 fs-12px-lh-15px ls-01em fw-normal">At least 1 number</span>
                    </li>
                    <li [ngClass]="{ 'valid': isLongEnough }">
                      <span *ngIf="isLongEnough">
                        <img src="../../assets/images/tick/tick.png" alt="tick" class="tick">
                      </span>
                      <span *ngIf="!isLongEnough">&#8226;</span>
                      <span class="ms-2 fs-12px-lh-15px ls-01em fw-normal">At least 8 characters</span>
                    </li>
                  </ul>
                </div>
                <div *ngIf="isPasswordBlurred && form.get('password')!.invalid && form.get('password')!.touched">
                  <div class="pe-2rem validation ps-2 pt-1 pe-7 g-1 fw-normal ls-01em font-outfit fs-12px-lh-15px">
                    <span>Your&nbsp;password&nbsp;is&nbsp;wrong.&nbsp;Remember&nbsp;that&nbsp;it&nbsp;must&nbsp;contain&nbsp;at&nbsp;least&nbsp;<b>8&nbsp;characters,&nbsp;1&nbsp;uppercase</b>&nbsp;and&nbsp;<b>1&nbsp;number</b></span>
                  </div>
                </div>
              </div>
              <div class="mt-6">
                  <button type="submit" class="media-screen-w bg-purple g-1 py-2 rounded-4 w-100 border-0 d-flex align-items-center justify-content-center box-sizing-border-box"
                          [disabled]="form.invalid">
                    <span class="sign-btn font-outfit col-white text-center fw-medium">
                      Create Account
                    </span>
                  </button>
              </div>
              <div class="mt-6 align-items-center d-flex">
                <hr class="hr-line mt-0 mb-0 ms-2 me-3 flex-fill">
                <span class="f-col">or</span>
                <hr class="hr-line mt-0 mb-0 ms-3 me-2 flex-fill">
              </div>
              <div class="mt-6">
                <button (click)="loginWithGoogle()" class="media-screen-w bg-white f-col g-1 py-2 rounded-4 w-100 d-flex align-items-center justify-content-center box-sizing-border-box b-1">
                  <img src="/assets/images/brand/google-icon.png" alt="google-icon" class="h-20px">
                    <span class="sign-btn f-col text-center fw-medium">
                      Continue with Google
                    </span>
                </button>
              </div>
              <p *ngIf="isGoogleLoginError" class="text-danger text-center">Google login failed. Please try again.</p>
            </form>
          </div>
        </div>
    </div>
  </section>
</main>
